export const PEDESTRIAN = 'Pedestrian'
export const BICYCLE = 'Bicycle'
export const TRANSIT = 'Transit'
export const AUTO = 'Auto'
export const FREIGHT = 'Freight'
export const MODAL_TIERS = 'modalTiers'
